import moment from 'moment'
import { ascBy, lowerCaseProperty } from '../../app/helpers/object'

/**
 * AddSubscribersActivityReportCtrl controller
 *
 * @class AddSubscribersActivityReportCtrl
 * @memberof mwApp/reports
 * @see mwApp/reports
 *
 * @ngdoc controller
 * @name mwApp/reports.controller:AddSubscribersActivityReportCtrl
 */
/* @ngInject */
export default function AddSubscribersActivityReportCtrl ($scope, $location, ReportSubscribersActivitySeed, commonData) {
  var vm = this

  /**
   * Listen tab event
   */
  $scope.$on('dispatch: subscribers_activity_reports', function () {
    $scope.$broadcast('refreshTable')
  })

  /**
   * Report state model
   *
   * @memberof mwApp/reports.controller:AddSubscribersActivityReportCtrl
   * @type {Object}
   */
  vm.report = new ReportSubscribersActivitySeed()

  /**
   * Packages list
   *
   * @memberof mwApp/reports.controller:AddSubscribersActivityReportCtrl
   * @type {Array}
   */
  vm.packages = []

  /**
   * Load extra data [packages, type]
   */
  ReportSubscribersActivitySeed.load('api/reports/subscriberactivity/extra', {
    networks: []
  }).then((data) => {
    vm.packages = [...data.networks]
    vm.packages.sort(ascBy(lowerCaseProperty('name')))
    vm.packages = [{ id: null, name: 'All Organizations' }].concat(vm.packages)
  })

  /**
   * Generate report
   *
   * @memberof mwApp/reports.controller:AddSubscribersActivityReportCtrl
   */
  vm.generateReport = function () {
    vm.setDisable()
    vm.report
      ._save(
        report => { if (report.networks.find((network) => network.id === null)) { report.networks = [] } },
        'api/reports/subscriberactivity'
      )
      .then(function (response) {
        const id = response.data.id
          ? response.data.id
          : response.data.payload ? response.data.payload.id : null
        $location.hash('generated_reports')

        commonData.data.update('lastReport', id)

        vm.location.reload()
      })
      .finally(vm.unsetDisable)
  }

  // cache default handler for datepicker
  const changeHandler = () => {
    if (moment().diff(vm.report.$fromDateTime, 'days') <= 0) {
      vm.report.$fromDateTime = moment().subtract(1, 'day').toDate()
    }

    if (moment().diff(vm.report.$toDateTime, 'days') <= 0) {
      vm.report.$toDateTime = moment().subtract(1, 'day').toDate()
    }
  }

  /**
   * Datepicker default settings
   *
   * @memberof mwApp/reports.controller:AddSubscribersActivityReportCtrl
   * @type {{format : string, changeHandler : AddSubscribersActivityReportCtrl.dpCfg.changeHandler}}
   */
  vm.dpCfg = {
    format: 'dd.MM.yyyy',
    minDate: moment().subtract(2, 'day').endOf('day').subtract(1, 'year').add(1, 'seconds').toDate(),
    maxDate: moment().subtract(1, 'day').toDate(),
    changeHandler
  }

  /**
   * Handle open "from" datepicker
   *
   * @memberof mwApp/reports.controller:AddSubscribersActivityReportCtrl
   */
  vm.openFrom = function () {
    vm.dpCfg.openedFrom = true
  }

  /**
   * Handle open "to" datepicker
   *
   * @memberof mwApp/reports.controller:AddSubscribersActivityReportCtrl
   */
  vm.openTo = function () {
    vm.dpCfg.openedTo = true
  }

  $scope.$watch('vm.report.networks', () => {
    const index = vm.report.networks.findIndex((network) => network.id === null)
    if (index > 0) {
      vm.report.networks = [{ id: null, name: 'All Organizations' }]
    }
    if (index === 0 && vm.report.networks.length > 1) {
      vm.report.networks.shift()
    }
  })
}
